export default "__VITE_ASSET__G5z6fRnv__"